import { ProductApiData } from "@src/interface/Product";
import { RollingStartEndpointBuilder } from "../apiTypes";
import type { IParticipationForm } from "@src/interface/GameParticipant";

export const createGameParticipantEndpoints = (
  builder: RollingStartEndpointBuilder
) => ({
  addGameParticipant: builder.mutation<ProductApiData, IParticipationForm>({
    query: (body) => ({
      url: `/gameparticipant`,
      method: "POST",
      body: {
        ...body,
        picto_id: body.pictoID,
        pictoID: undefined,
      },
    }),
  }),
});
